export default "__VITE_ASSET__Dlf93gVG__"